import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-foreground-950">
                <i className="ri-clapperboard-fill text-xl"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">ai短剧</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-200">
              ai短剧是聚焦人工智能短剧作品的内容推荐与资讯平台，聚合多类型创新短视频作品，
              提供最新短剧动态、剧情介绍与创作背景，帮助观众发现下一部想看的 AI 短剧。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="mailto:hello@ai-duanju.example.com"
                className="inline-flex items-center gap-2 rounded-md bg-background-50/10 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-background-50/20"
              >
                <i className="ri-mail-line text-base"></i>
                hello@ai-duanju.example.com
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold tracking-wide text-background-50">快速导航</h3>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to="/" className="text-secondary-200 transition-colors hover:text-accent-400">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category" className="text-secondary-200 transition-colors hover:text-accent-400">
                  短剧分类
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-secondary-200 transition-colors hover:text-accent-400">
                  短剧资讯
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-secondary-200 transition-colors hover:text-accent-400">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold tracking-wide text-background-50">热门分类</h3>
            <ul className="mt-4 flex flex-wrap gap-2">
              {categories.slice(0, 6).map((item) => (
                <li key={item.id}>
                  <Link
                    to={`/category?type=${item.id}`}
                    className="inline-flex items-center rounded-full bg-background-50/10 px-3 py-1.5 text-xs text-secondary-200 transition-colors hover:bg-accent-500 hover:text-foreground-950"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-50/15 pt-6 text-xs text-secondary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} ai短剧 · 本站内容与人物均为虚构演示，仅供产品展示。</p>
          <p className="flex items-center gap-2">
            <i className="ri-information-line"></i>
            站内短剧播放为示范占位，不提供真实播放服务
          </p>
        </div>
      </div>
    </footer>
  );
}